import { LoadFinderBaseMesage, LoadFinderActionTypes, ISingleLoadUpdateMessage, LoadUpdateTypes, IMultiLoadUpdateMessage } from '@numeo/types'
import { WsMessageCategory } from '@numeo/types-core'
import { AppDispatch, RootState } from 'store'
import { setLoadsForTruck, updateIngestedLoad } from 'store/loadSearchSlice'
import { audioService } from 'utils/audioService'
import { playNotificationSoundIfEnabled } from 'utils/notificationSoundUtils'

export const handleLoadFinderMessages = (
    message: LoadFinderBaseMesage,
    dispatch: AppDispatch,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
    getState: () => RootState
): boolean => {
    if (message.categoryType !== WsMessageCategory.LoadFinder) return false

    try {
        switch (message.data.action) {
            case LoadFinderActionTypes.LF_SingleLoadUpdate: {
                const subtype: ISingleLoadUpdateMessage = message.data
                const truckId = subtype.truckId
                const load = subtype.load
                const type = subtype.type

                dispatch(
                    setLoadsForTruck({
                        truckId,
                        loads: { [load._id]: load },
                        isNewLoad: type === LoadUpdateTypes.LOAD_CREATED,
                    })
                )
                const notificationsEnabled = localStorage.getItem(`truck_notifications_${truckId}`) === 'true'

                if (type === LoadUpdateTypes.LOAD_CREATED && notificationsEnabled) {
                    playNotificationSoundIfEnabled(audioService)
                }

                break
            }
            case LoadFinderActionTypes.LF_MultiLoadUpdate: {
                const subtype: IMultiLoadUpdateMessage = message.data
                const truckId = subtype.truckId
                const loads = subtype.loads

                const loadValues = Object.values(loads)
                const isLoadboardMessage =
                    loadValues.length > 0 && loadValues.some((load) => load.type && ['DAT', 'TRUCKSTOP', 'UBER', '123LOADBOARD'].includes(load.type))

                const isNewLoad = isLoadboardMessage || subtype.isNewLoad === true || message.data?.isNewLoad === true

                dispatch(
                    setLoadsForTruck({
                        truckId,
                        loads,
                        isNewLoad,
                    })
                )

                if (isNewLoad && Object.keys(loads).length > 0) {
                    const notificationsEnabled = localStorage.getItem(`truck_notifications_${truckId}`) === 'true'

                    if (notificationsEnabled) {
                        playNotificationSoundIfEnabled(audioService)
                    }
                }

                break
            }
            case LoadFinderActionTypes.LF_LoadIngested: {
                const load = message.data.load
                dispatch(updateIngestedLoad(load))
                break
            }

            default:
                return false
        }

        return true
    } catch (error) {
        console.error('Error parsing server message:', error)
        return false
    }
}
